import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsGetStartedRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-get-started',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/get-started',
	exact: true,
};
